<template>
  <div
    style="width: 100%; height: 100%;"
  >
    <div
      v-if="config.label"
      class="field-label"
      :style="getLabelStyle()"
    >
      {{ config.label }}
    </div>
    <div
      style="height: 100%;"
      :style="{ cursor: config && !config.editable && config.editable !== undefined ? 'not-allowed' : 'default' }"
    >
      <v-textarea
        v-model="computedValue"
        :outlined="config.outlined || true"
        :density="config.density || 'compact'"
        :hide-details="config.hideDetails || 'auto'"
        :disabled="disabled"
        :error-messages="getValidationErrors()"
        :error-count="getValidationErrors().length"
        :clearable="config.clearable || false"
        :prepend-inner-icon="config.prependInnerIcon || undefined"
        :append-icon="config.appendIcon || undefined"
        :placeholder="config.placeholder || undefined"
        :autofocus="config.autofocus || false"
        v-bind="bindProps"
        :type="config.type || 'text'"
        :style="getFieldStyle()"
        :class="getFieldClasses()"
        @click="event => $emit('click', event)"
        @click:append="event => $emit('append-click', event)"
        @click:append-inner="event => $emit('append-inner-click', event)"
        @input="onInput"
      >
        <template
          v-if="config.appendInnerIcon"
          #append-inner
        >
          <v-icon
            ref="appendInner"
          >
            {{ config.appendInnerIcon || undefined }}
          </v-icon>
        </template>
      </v-textarea>
    </div>
  </div>
</template>

<script>
import { isEmpty, isObject } from 'lodash'
export default {
  name: 'TextareaField',

  props: {
    value: {
      type: [Number, String, Object, Array],
      default: null
    },
    config: {
      type: Object,
      default: () => ({})
    },
    validationErrors: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: null
    },
    bindProps: {
      type: Object,
      default: () => ({})
    }
  },

  emits: [
    'input',
    'click',
    'append-click',
    'append-inner-click',
    'clear-validation-errors'
  ],

  computed: {
    computedValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },

  methods: {
    getValidationErrors () {
      let messages = []
      const { key: fieldKey } = this.config || {}

      if (isEmpty(this.validationErrors) || !fieldKey) {
        return messages
      }

      for (const errorKey in this.validationErrors) {
        if (errorKey === fieldKey) {
          messages = this.validationErrors[errorKey]
        }
      }

      return messages
    },

    getFieldStyle () {
      const { editable, style: fieldStyle } = this.config || {}
      let style = {}

      if (!editable && editable !== undefined) {
        style.backgroundColor = '#E5E7EB'
      }
      else {
        style.backgroundColor = ''
      }

      if (fieldStyle && isObject(fieldStyle)) {
        style = {
          ...style,
          ...fieldStyle
        }
      }

      return style
    },

    getFieldClasses () {
      const { class: fieldClass } = this.field || {}
      let classes = 'mt-1 textarea'

      if (this.disabled) {
        classes += ' textarea-disabled'
      }

      if (fieldClass && typeof fieldClass === 'string') {
        classes += ' ' + fieldClass
      }

      return classes
    },

    getLabelStyle () {
      const { labelStyle } = this.field || {}
      let style = {}

      if (labelStyle && isObject(labelStyle)) {
        style = {
          ...style,
          ...labelStyle
        }
      }

      return style
    },

    onInput () {
      this.$emit('clear-validation-errors')
    }
  }
}
</script>

<style scoped>
.field-label {
  font-family: 'Satoshi', sans-serif;
  font-size: 14px;
  color: #111827;
  line-height: 20px;
  font-weight: 500;
}

.textarea-disabled {
  background-color: #F4F4F5 !important;
}

::v-deep {
  .v-text-field--outlined fieldset {
    border-color: #E5E7EB !important;
    border-radius: 8px !important;
  }
}

::v-deep.textarea > .v-input__control > .v-input__slot > .v-text-field__slot > textarea {
  font-family: 'Satoshi', sans-serif;
  font-size: 14px !important;
  line-height: 20px !important;
  color: #111827 !important;
  font-weight: 500 !important;
}

::v-deep.v-input--is-disabled > .v-input__control > .v-input__slot > .v-text-field__slot > textarea {
  font-family: 'Satoshi', sans-serif;
  font-size: 14px !important;
  line-height: 20px !important;
  color: #9CA3AF !important;
  font-weight: 400 !important;
}
</style>
